
<script>
import HomeButton from "@/components/HomeButton";
import features from "@/configs/features";
import { useUserStore } from "../stores/user";
import WelcomeBoard from "./lang-specific/WelcomeBoard";
import { useI18n } from "vue-i18n";
export default {
  setup() {
    const { t } = useI18n();
    const userStore = useUserStore();
    const isAdmin = userStore.isAdmin;
    return { isAdmin, t };
  },
  components: {
    HomeButton,
    WelcomeBoard,
  },
  computed: {
    features: () => features,
    buttons() {
      const buttons = [];
      if (this.isAdmin) {
        buttons.push({
          title: "views.home.buttons.admin",
          icon: "home",
          route: "/admin",
        });
      } else {
        buttons.push({
          title: "views.home.buttons.mairie",
          icon: "home",
          route: this.t("path.mairie"),
        });
      }
      if (features.LEGIS) {
        buttons.push({
          title: "views.home.buttons.reglementation",
          icon: "balance-scale",
          route: this.t("path.legis"),
        });
      }
      buttons.push({
        title: "views.home.buttons.faq",
        icon: "info-circle",
        route: this.t("path.faq"),
      });

      return buttons;
    },
  },
};
</script>


<template>
  <div class="mt-16 px-8 w-full">
    <h1 class="text-3xl text-center font-bold text-lightGrey leading-tight">
      {{ $t("views.home.title") }}
    </h1>
    <div v-if="features.HOME_SUBTITLE" class="w-full px-24 text-s leading-snug text-lightGrey">
      <br />
      <p v-html="$t('views.home.sub_title')"></p>
    </div>
    <div :class="[buttons.length < 3 ? 'sm:justify-evenly' : 'sm:justify-around']"
      class="flex flex-col md:flex-row w-full py-10">
      <HomeButton v-for="button in buttons" :key="button.title" :button="button" class="w-full lg:w-56" />
    </div>
    <div v-if="features.VERSION == 'fr'">
      <hr class="my-8 border border-solid border-gray-200" />
      <div
        class="w-full p-8 mb-12 border border-solid border-gray-300 rounded shadow-md text-s leading-snug text-lightGrey">
        <WelcomeBoard />
      </div>
    </div>
  </div>
</template>
